import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Modal,
  Alert,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { Multiselect } from "multiselect-react-dropdown";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
function CategoryManagment() {
  var history = useHistory();
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  const [imageKey, setImageKey] = useState("");
  const [allCategory, setAllCategory] = useState([]);
  const [allCategoryObject, setAllCategoryObject] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [imageData, setImageData] = useState(null);
  const [image, setImage] = useState(null);
  const [categoryName, setCategoryName] = useState("");
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [catId, setCatId] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [show1, setShow1] = useState(false);
  const [category, setCategory] = useState("");
  const [selectedCategory, setSelectedCategory] = useState([]);
  function getData() {
    axios
      .get(`${Baseurl.baseurl6}/go-grocery/sub-shop/get-all-sub-shop`)
      .then((res) => {
        console.log("categoiryeueye", res.data.details);
        setSpinner(false);
        setAllCategory(res.data.details);
        setSearchData(res.data.details);
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function searchRider(value) {
    let filteredData = [];
    searchData.map((val) => {
      if (val.Name.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setAllCategory(filteredData);
  }
  const onChangePicture = (e) => {
    if (e.target.files[0].size / 1048576 < 3) {
      setImage(e.target.files[0]);
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          setImageData(reader.result);
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
      setImageData(null);
    }
  };
  function addCategory() {
    const data = new FormData();
    data.append("image", image);
    data.append("name", categoryName);
    var config = {
      method: "post",
      url: `${Baseurl.baseurl6}/go-grocery/sub-shop/create-sub-shop`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();
          setImage(null);
          setImageData(null);

          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});

    handleClose();
  }
  function updateCategory() {
    let catFields = {
      name: categoryName,
    };
    axios
      .put(
        `${Baseurl.baseurl6}/go-grocery/sub-shop/update-sub-shop-name/${catId}`,
        catFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  function updateCategoryImage() {
    const data = new FormData();
    data.append("image", image);
    var config = {
      method: "put",
      url: `${Baseurl.baseurl6}/go-grocery/sub-shop/update-sub-shop-image/${catId}`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();
          setImage(null);
          setImageData(null);
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });

    handleClose();
  }
  function deleteCategory() {
    axios
      .delete(
        `${Baseurl.baseurl6}/go-grocery/sub-shop/update-grocery-category-image/${catId}`
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }

  function updateFunction(val) {
    setCatId(val._id);
    setUpdateStatus(true);

    setCategoryName(val.Name);

    setImageData(val.Image);
    setImageKey(val.ImageKey);
    setShow(true);
  }
  function getCategory(category){
    axios
    .get(`${Baseurl.baseurl6}/go-grocery/category/get-all-grocery-category`)
    .then((res) => {
      setAllCategoryObject(res.data.details);
      setSelectedCategory(category)
    });
  }
  const selection1 = (selectedValues) => {
    let name = [];
    selectedValues.map((val) => {
      name.push(val._id);
    });
    
    setCategory(name);
  };
  function deleteCategoryfromSubShop(id){
    let catFields = {
        categoryId: id,
      };
      axios
        .put(
          `${Baseurl.baseurl6}/go-grocery/sub-shop/remove-category-sub-shop/${catId}`,
          catFields
        )
        .then((response) => {
          if (response.data.status) {
            getData();
            swal("deleted", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
      setShow1(false)
  }
  const removeFromSubStore = (selectedValues,removed) => {
    console.log("selectionsss",removed)
    if(removed&&deleteStatus){
      deleteCategoryfromSubShop(removed._id)
    }
  };
  
  function addCategoryToSubStore(){
    if(selectedCategory.length!==0){
        category.splice(0, selectedCategory.length);
    }
    let catFields = {
        categoryId: category,
      };
      axios
        .put(
          `${Baseurl.baseurl6}/go-grocery/sub-shop/add-category-sub-shop/${catId}`,
          catFields
        )
        .then((response) => {
          if (response.data.status) {
            getData();
            swal("updated", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
      setShow1(false)
  }
  return (
    <Col lg={12}>
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{deleteStatus?"Remove Category":"Add Category"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
        <div className="row">
        <div className="col-sm-2">
            
              <label className="col-form-label" htmlFor="val-confirm-password">
                Category<span className="text-danger">*</span>
              </label>
            </div>
            <div className="col-sm-10">
              <Multiselect
                options={allCategoryObject}
                displayValue="Name"
                onRemove={removeFromSubStore}
                onSelect={selection1}
                selectedValues={selectedCategory}
              />
            </div>
        </div>
        </Modal.Body>
        {!deleteStatus&&(
              <Modal.Footer>
              <button
                onClick={() => {
                 addCategoryToSubStore()
                }}
                className="btn btn-primary"
              >
                ADD
              </button>
            </Modal.Footer>
        )}
      
      </Modal>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Add Sub Shop</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="row">
              <div className="col-sm-1 mt-2">
                <label>
                  Name <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={categoryName}
                  type="text"
                  className="form-control"
                  placeholder="enter Name"
                  onChange={(e) => setCategoryName(e.target.value)}
                  required
                />
              </div>
              <div className="col-sm-2 mt-2">
                <label htmlFor="val-range">
                  Image
                  <span className="text-danger">*</span>
                </label>
              </div>
              <div classname="col-sm-4">
                <div className="register_profile_image mt-2">
                  <input
                    id="profilePic"
                    type="file"
                    onChange={(e) => {
                      onChangePicture(e);
                    }}
                  />
                </div>
                {imageData && (
                  <div
                    style={{
                      marginTop: "5px",
                      width: 180,
                      height: 100,
                      aspectRatio: 1 * 1.4,
                    }}
                    className="previewProfilePic"
                  >
                    <img
                      alt=""
                      className="playerProfilePic_home_tile"
                      style={{
                        resizeMode: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                      src={imageData}
                    />
                  </div>
                )}
                {updateStatus && (
                  <div className="col-sm-2 ">
                    <button
                      onClick={() => {
                        updateCategoryImage();
                      }}
                      className="btn btn-primary mt-3"
                    >
                      Change
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {updateStatus ? (
            <button
              className="btn btn-primary"
              onClick={() => {
                updateCategory();
              }}
            >
              Update
            </button>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                addCategory();
              }}
            >
              Submit
            </button>
          )}
        </Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
          <button
            onClick={() => {
              setShow(true);
              setUpdateStatus(false);

              setImageData(null);

              setCategoryName("");
            }}
            className="btn btn-primary"
          >
            Add Sub Shop
          </button>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>SL NO.</strong>
                    </th>

                    <th>
                      <strong>Image</strong>
                    </th>

                    <th>
                      <strong> Name</strong>
                    </th>

                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allCategory &&
                    allCategory.map((val, key) => (
                      <tr key={val._id}>
                        <td>{key + 1}</td>
                        <td>
                          <img
                            src={val.Image}
                            height={40}
                            width={40}
                            alt="profile"
                          />
                        </td>
                        <td>{val.Name}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  updateFunction(val);
                                }}
                              >
                                Update
                              </Dropdown.Item>

                              <Dropdown.Item
                                onClick={() => {
                                  setCatId(val._id);
                                  setShow1(true);
                                  getCategory(val.Category)
                                  setDeleteStatus(false)
                                 
                                }}
                              >
                                Add Category
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setCatId(val._id);
                                  setShow1(true);
                                  getCategory(val.Category)
                                  setDeleteStatus(true)
                                }}
                              >
                                Remove Category
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!allCategory && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero allCategory
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default CategoryManagment;
